import { Constants } from '../constants';
import { PerformanceIndicator } from '../models/performanceIndicator';
import { ResourceCharacteristicTypeBounds } from '../models/resourceCharacteristicTypeBounds';

export class PerformanceInidicatorHelper {
    public static getPerformanceColor(pi: PerformanceIndicator, swapColors: boolean) {
      if (pi.targetValue === 0 || !pi.targetValue || !pi.actualValue) {
        return Constants.UNDETERMINED_PERFORMANCE_CLASS;
      }

      if (pi.boundType === ResourceCharacteristicTypeBounds.Unbounded) {
        return Constants.NEUTRAL_PERFORMANCE_CLASS;
      }

      return pi.boundType === ResourceCharacteristicTypeBounds.UpperBounded
        ? this.getUpperBoundedPerformanceIndicatorColor(pi,swapColors)
        : this.getLowerBoundedPerformanceIndicatorColor(pi,swapColors);
    }

    private static getUpperBoundedPerformanceIndicatorColor(pi: PerformanceIndicator,swapColors: boolean) {
      if (pi.calculatedValue >= 110) {
        return !swapColors ? Constants.NEGATIVE_PERFORMANCE_CLASS : Constants.POSITIVE_PERFORMANCE_CLASS;
      } else {
        return pi.calculatedValue >= Constants.PI_THRESHOLD
          ? Constants.YELLOW_PERFORMANCE_CLASS
          : !swapColors
            ? Constants.POSITIVE_PERFORMANCE_CLASS
            : Constants.NEGATIVE_PERFORMANCE_CLASS;
      }
    }

    private static getLowerBoundedPerformanceIndicatorColor(pi: PerformanceIndicator,swapColors: boolean) {
      if (pi.calculatedValue >= 100) {
        return !swapColors ? Constants.POSITIVE_PERFORMANCE_CLASS : Constants.NEGATIVE_PERFORMANCE_CLASS;
      } else {
        return pi.calculatedValue >= Constants.PI_THRESHOLD
          ? Constants.YELLOW_PERFORMANCE_CLASS
          : !swapColors
            ? Constants.NEGATIVE_PERFORMANCE_CLASS
            : Constants.POSITIVE_PERFORMANCE_CLASS;
      }
    }

}
